module.exports = __webpack_public_path__ + "static/media/34-15.5348f6d0.mp3";